import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import DocStyleTemplatesDropdown, {
  TEMPLATES_ERROR_MESSAGE,
} from "components/DocStyleTemplatesDropdown";
import { modalTypes } from "constants/types";
import { func } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import isNullish from "utils/isNullish";

import classes from "./GenericDeleteModal.module.scss";

const ConfirmDocStyleTemplateModal = ({ onConfirmTemplate = () => {} }) => {
  const dispatch = useDispatch();
  const [templateId, setTemplateId] = useState();
  const [error, setError] = useState();

  const onSelectTemplate = (id) => {
    setError(undefined);
    setTemplateId(id);
  };

  const onClickConfirm = () => {
    if (isNullish(templateId)) {
      setError(TEMPLATES_ERROR_MESSAGE);
      return;
    }

    dispatch(hideModal(modalTypes.CONFIRM_DOC_STYLE_TEMPLATE_MODAL));
    onConfirmTemplate(templateId);
  };

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.CONFIRM_DOC_STYLE_TEMPLATE_MODAL));
  };

  return (
    <Modal
      data-testid="generic-delete-modal"
      className="fade-in"
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Choose your Style Template</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>Choose the styles which work best for this document.</p>

        <DocStyleTemplatesDropdown error={error} onSelect={onSelectTemplate} />
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Generate
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmDocStyleTemplateModal.propTypes = {
  onConfirmTemplate: func,
};

export default ConfirmDocStyleTemplateModal;
